module.exports = __webpack_public_path__ + "static/img/tiktok_qrcode.6a51a96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tiktok_qrcode.jpg
// module id = L1r0
// module chunks = 1